<ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data | async" [attr.aria-label]="widgetTitle"></ag-grid-angular>
<div class="grid-x margin-top margin-right">
    <div class="cell text-align-right">
        <a routerLink="/letters" aria-label="View Sent Mail">View Sent Mail  <img style="height: 14px; width: 14px;" src="../../../../../assets/images/SVG/angle-double-right-solid.svg" /></a>
    </div>
</div>
